import { createSlice } from "@reduxjs/toolkit";

import { ExecutorPenalty } from "../../../../../services";
import { ReduxReducer } from "../../../../interface";
import { GlobalState } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	subscription: {
		basic: [],
	},
};

const setSubscriptionBasicData: ReduxReducer<State, ExecutorPenalty.Model[]> = (
	state,
	action,
) => {
	state.subscription.basic = action.payload;
};

const reset: ReduxReducer<State, any> = (state) => {
	Object.keys(initialState).forEach((key) => {
		state[key] = initialState[key];
	});
};

const globalStateExecutorPenaltyData = createSlice({
	name: GlobalState.ConstantGlobalStateSlice.EXECUTOR_PENALTY_DATA,
	initialState,
	reducers: {
		reset,
		setSubscriptionBasicData,
	},
});

export const globalStateExecutorPenaltyDataAction =
	globalStateExecutorPenaltyData.actions;
export const globalStateExecutorPenaltyDataReducer =
	globalStateExecutorPenaltyData.reducer;
export type globalStateExecutorPenaltyDataState = State;

export default globalStateExecutorPenaltyData;
